export enum Constant {
    access_token = 'access_token',
    refresh_token = 'Refresh_Token',
    user = 'User'
}